
import * as SampleDaysTypes from '../dictionaries/sample-days-types'


export default {
    initialized: false,
    devMode: false,
    availableLanguages: [
        {
            value: 'ru',
            text: 'Русский'
        },
        {
            value: 'en',
            text: 'English'
        }
    ],
    availableGenders: [
        {
            title: 'Male',
            value: 'm'
        },
        {
            title: 'Female',
            value: 'f'
        }
    ],
    //hours
    availableExecutionPeriods: [
        24,
        72,
        144,
        216
    ],
    availableSampleDaysTypes: [
        {
            name: 'Work',
            value: SampleDaysTypes.Work
        },
        {
            name: 'Calendar',
            value: SampleDaysTypes.Calendar
        }
    ],
    availableClinicalData: [],
    availableSpecialists: [],
    fileViewerData: {
        file: {
            source: null,
            title: null,
            mimeType: null,
            downloadFileName: null
        }
    },
    progress: {}
}